// See: https://www.rma.usda.gov/ftp/Publications/M13_Handbook/2020/approved/P99F_1_INSURANCE_PLAN_CODE_LIST_EXHIBIT.PDF

export const RmaInsurancePlanCodes = {
  // NOTE: RMA contains additional plan codes that are not included here as they are not used
  LRP: '81',
  LGM: '82',
} as const;

export type RmaInsurancePlanCodes =
  (typeof RmaInsurancePlanCodes)[keyof typeof RmaInsurancePlanCodes];
